import { render, staticRenderFns } from "./NationalTrademarkSearch.vue?vue&type=template&id=f68d38f6&"
import script from "./NationalTrademarkSearch.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports